import { DrmMediaItem, Video } from 'types/api/media';

export enum DRMPlatform {
  BRIGHTCOVE = 'brightcove',
}

export enum DrmType {
  WIDEVINE = 'widevine',
  PLAYREADY = 'playready',
}

export const DRM_KEY_SYSTEMS: Record<DrmType, string> = {
  [DrmType.WIDEVINE]: 'com.widevine.alpha',
  [DrmType.PLAYREADY]: 'com.microsoft.playready',
};

export type DRMData = {
  hasDrm: boolean;
  licenseUrl?: string;
  videoSrc?: string;
  token?: string;
};

export default abstract class DRMService {
  abstract readonly platform: DRMPlatform;

  abstract getDRMData(
    content: Video | DrmMediaItem,
  ): Promise<DRMData | undefined>;

  getDashItem(drmItems: DrmMediaItem[]) {
    return drmItems.find(item => item.mimeType.includes('dash+xml'));
  }
}
